export default {
    celular(value) {
        if (value) {
            return value.replace(/\(|\)|-|\s/g, '')
        }
    },
    certidao(value) {
        if (value) {
            return value.replace(/\s/g, '')
        }
    },
    cep(value) {
        if (value) {
            return value.replace(/\.|-/g, '')
        }
    },
    cpf(value) {
        if (value) {
            return value.replace(/\.|-/g, '')
        }
    },
    telefone(value) {
        if (value) {
            return value.replace(/\(|\)|-|\s/g, '')
        }
    },
}